// Mirrors the suffix list from the deployed VOD source-bucket S3 trigger.
// If you add an extension here it MUST also be registered on the source bucket's S3 notifications.
export const SUPPORTED_EXTENSIONS = [
  '.mp4',
  '.mov',
  '.m4v',
  '.mkv',
  '.webm',
  '.mpg',
  '.mpeg',
  '.m2ts',
  '.wmv',
  '.mxf',
  '.m3u8',
  '.h264',
] as const;

export function isSupportedExtension(filename: string): boolean {
  const lower = filename.toLowerCase();
  return SUPPORTED_EXTENSIONS.some((ext) => lower.endsWith(ext));
}

export function supportedExtensionsHumanList(): string {
  return SUPPORTED_EXTENSIONS.join(', ');
}
